import getIsOnlineMeetingsByDefaultSynced from '../selectors/getIsOnlineMeetingsByDefaultSynced';
import { getStore } from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getDefaultOnlineMeetingEnabled } from 'owa-session-store';

/**
 * We need to sync if:
 * - the sync flight is enabled
 * - we haven't synced already
 * - the OCS setting is false
 * - the mailbox config setting is true
 */
export default function shouldSyncOnlineMeetingsByDefault(): boolean {
    return (
        isFeatureEnabled('cal-mf-onlineMeetingSyncOCSWithMailboxConfig') &&
        !getIsOnlineMeetingsByDefaultSynced() &&
        !getStore().enableOnlineMeetingsByDefault &&
        getDefaultOnlineMeetingEnabled()
    );
}
